import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Footer from 'components/common/footer/Footer';
import Header from 'components/common/header/Header';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Breadcrumb from '../../components/common/breadcrumb/breadcrumb';
import ErrorBoundary from '../../ErrorBoundary';
import RoadCondition from './RoadCondition';
import styles from './RoadCondition.module.scss';
import SpecialEvent from './SpecialEvent';
import XmlEditors from './XmlEditors';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { useHistory } from "react-router";

const useStyles = makeStyles((theme)=>({
    root: {
        flexGrow: 1,
        backgroundColor: "#002664",
        color:"#fff"
    },
    pageMargin: {
        margin: "0 6%",
        minHeight: '480px'
    },
    marginTop:{
        marginTop: '3%'
    }
}));


const breacrumbItems = [
    {
        label:"Home",
        href:"/"
    },
    {
        label:"Road Conditions Editor"
    }
];

const Index = props => {
    const classes = useStyles();
    const history=useHistory();
    const [value, setValue] = React.useState(0);
    const [preValue, setPreValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
         setValue(newValue);
         if(newValue === 1){
             breacrumbItems.splice(1);
             breacrumbItems.push({label:'Special Events Editor'})
         }
         else if(newValue === 2){
            breacrumbItems.splice(1);
            breacrumbItems.push({label:'Xml Files'})
         }
         else {
            breacrumbItems.splice(1);
            breacrumbItems.push({label:'Road Conditions Editor'})
         }
    };
    const handleChange = ( newValue) => {
      setPreValue(newValue);
        setValue(newValue);
    };
    const handleHelp = () => {
        history.push('/RoadConditionsHelp'); 
      };
    const successToast=(toastMessage) => {
            toast.success(toastMessage, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000,
                className: styles.toastSuccess
            });
    };
    const errorToast=(toastMessage) => {
            toast.error(toastMessage, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000
            });
    };
    return (
        <div>
            <Header />
            <ErrorBoundary>
             <div className={classes.pageMargin}>
                <div className={classes.bar}>
                    <Breadcrumb items={breacrumbItems}></Breadcrumb>
                    <a title="Help" className={styles.helpIcon} target="_blank" href={process.env.REACT_APP_BASE_URL+"/help/transport-ivr-messaging-application-help-road-conditions-editor-08062021/content/index.html"}>
                    <HelpOutline className="icon" style={{ fontSize: "30px" }} />
                    </a>
                </div>
            <ToastContainer className={styles.toastContainer} />  
                <Paper className={classes.root}>
                    <Tabs
                        value={value}
                        onChange={handleTabChange}
                        TabIndicatorProps={{
                            style: {
                            backgroundColor: "#fff",
                            height:"3px",
                            marginBottom:"2px",
                            outline:"0"
                            }
                        }}
                    >
                        <Tab label="Road Conditions" />
                        <Tab label="Special Events" />
                        <Tab label="XML File" />
                    </Tabs>
                </Paper>
                {preValue === 0 ? <RoadCondition nextTabIndex={value} handleChange={handleChange} successToast={successToast} errorToast={errorToast}/> 
                : preValue === 1 ? <SpecialEvent nextTabIndex={value} handleChange={handleChange} successToast={successToast} errorToast={errorToast}/> 
                    : <XmlEditors nextTabIndex={value} handleChange={handleChange} successToast={successToast} errorToast={errorToast}/>}
            </div>
            <div className={classes.marginTop}>
            <Footer />
            </div>
            </ErrorBoundary>
        </div>
    );
}

export default withRouter(props => <Index {...props} />);
